import { PartnerPartnerDetails } from 'vopay';
import type { AccountCredentials } from '@/components/Entities/Accounts/AccountHeaderCards/accountCredentials';

/**
 * The credentials strip's input for a partner account, or null when there is nothing to show. The
 * backend sends the key pair only for an Active partner account with an active API key (ID-13788
 * product decision 1), so their presence is the whole gate — shared by the drawer and the page.
 */
export default function toPartnerCredentials(details: PartnerPartnerDetails | undefined): AccountCredentials | null {
  if (!details?.ApiKey || !details.ApiSharedSecret) return null;

  return {
    accountId: details.PartnerAccountID,
    apiKey: details.ApiKey,
    secret: details.ApiSharedSecret,
    secretKind: 'sharedSecret',
  };
}
